import React, { useContext, useRef } from 'react'
import { Dropdown } from 'react-bootstrap'
import CustomDropdownToggle from '../../custom/CustomDropdownToggle'
import Icon from 'icons/Icon'

const CountryField = ({ formik, contextValue, disabled = false }) => {
  const { allCountries, setSearch, search, userDetails, languageData } = useContext(contextValue)
  const { values, setFieldValue, setFieldTouched, validateField, errors, touched } = formik
  const dropdownRef = useRef(null)
  const hasError = errors?.countryCode && touched?.countryCode
  const placeholderText = languageData?.selectCountryCode || 'Select Country'
  const selectedCountry = allCountries?.rows?.find(({ code }) => code === values?.countryCode)

  return (
    <Dropdown
      className={`country-code icon-left ${disabled ? 'pe-none' : ''}`}
      onClick={() => setFieldTouched('countryCode', true)}
      id='countryCode'
      ref={dropdownRef}
    >
      <Dropdown.Toggle
        id='dropdown-basic'
        as={CustomDropdownToggle}
        hasError={hasError}
        disabled={userDetails ? [0, 1, '0', '1'].includes(userDetails?.kycMethod) || userDetails?.claimedBonus : false}
        style={{ textAlign: 'left !important' }}
        onKeyDown={(e) => {
          // for search, allowed keys are alphabets only.
          if (dropdownRef?.current?.querySelector('.show') && /^[a-zA-Z]$/.test(e.key)) {
            setSearch(search + e.key)
          } else if (e.key === 'Backspace' || e.key === 'Delete') {
            setSearch('')
          }
        }}
        onClickCapture={(e) => {
          if (dropdownRef?.current?.querySelector('.show')) {
            setSearch('')
          }
        }}
      >
        <span>{selectedCountry ? selectedCountry.name : placeholderText}</span>
        <Icon name='drop-arrow' className='drop-arrow-icon' />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className='scrollDropdown'>
          <Dropdown.Item disabled>{placeholderText}</Dropdown.Item>
          {allCountries?.rows?.map(({ name, code }) => {
            if (name.toLowerCase().startsWith(search?.toLowerCase())) {
              return (
                <Dropdown.Item
                  key={`${name}-${code}`}
                  onClick={async () => {
                    await setFieldValue('countryCode', code)
                    validateField('countryCode')
                  }}
                >{name}
                </Dropdown.Item>
              )
            }

            return null
          }
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default CountryField
